<main class="qca-billing-page">
  <div class="page-shell">
    <header class="page-header app-card">
      <div>
        <h1>QCA Billing</h1>
        <span>Pooling sub-station deviation charge summary for {{ qca()?.qcaName || 'selected QCA' }}.</span>
      </div>
      <div class="header-actions ms-auto">
        <div class="filter-grid">
          <label class="filter-field" for="financial-year">
            <select id="financial-year" class="app-form-select" [value]="selectedFinancialYear()" (change)="changeFinancialYear($any($event.target).value)">
              @for (financialYear of financialYears; track financialYear) { <option [value]="financialYear">{{ financialYear }}</option> }
            </select>
          </label>
          <label class="filter-field" for="billing-week">
            <select id="billing-week" class="app-form-select" [value]="selectedWeek()" (change)="selectedWeek.set($any($event.target).value)">
              @for (week of weeks(); track week.id) { <option [value]="week.id" [selected]="week.id === selectedWeek()">{{ week.label }}</option> }
            </select>
          </label>
        </div>
        <button type="button" class="app-button app-button--secondary" (click)="goBack()">← Back to Billing</button>
      </div>
    </header>

    <section class="table-card app-card">
      <div class="table-wrap">
        <table class="billing-report-table">
          <thead>
            <tr><th rowspan="3">Sr. No.<br>(a)</th><th rowspan="3">Name of Pooling Sub-station<br>(b)</th><th colspan="3">Intra-State Transactions</th><th colspan="2">Inter-State Transactions</th></tr>
            <tr><th>PART - A</th><th colspan="2">PART - B*</th><th colspan="2">PART - A</th></tr>
            <tr><th>Deviation Charges @ PSS level (Rs.)<br>Payable to Pool (c)</th><th>Deviation Charges @ State Periphery (Rs.)<br>Payable to Pool (d)</th><th>Receivable from Pool (e)</th><th>Deviation Charges @ PSS level (Rs.)<br>Payable to Pool (f)</th><th>Receivable from Pool (g)</th></tr>
          </thead>
          <tbody>
            @for (row of pssRows(); track row.pssCode; let index = $index) {
              <tr><td>{{ index + 1 }}</td><td><strong>{{ row.pssName }}</strong></td><td>{{ row.payableAtPss | currency: 'INR': 'symbol': '1.2-2' }}</td><td>{{ row.payableToPool | currency: 'INR': 'symbol': '1.2-2' }}</td><td>{{ row.receivableFromPool | currency: 'INR': 'symbol': '1.2-2' }}</td><td>{{ row.interPayableToPool | currency: 'INR': 'symbol': '1.2-2' }}</td><td>{{ row.interReceivableFromPool | currency: 'INR': 'symbol': '1.2-2' }}</td></tr>
            } @empty {
              <tr><td colspan="7" class="empty-state">No linked PSS billing records are available for this QCA.</td></tr>
            }
          </tbody>
          <tfoot>
            <tr><th colspan="2">Sub Total (Rs.)</th><th>{{ totals().payableAtPss | currency: 'INR': 'symbol': '1.2-2' }}</th><th>{{ totals().payableToPool | currency: 'INR': 'symbol': '1.2-2' }}</th><th>{{ totals().receivableFromPool | currency: 'INR': 'symbol': '1.2-2' }}</th><th>{{ totals().interPayableToPool | currency: 'INR': 'symbol': '1.2-2' }}</th><th>{{ totals().interReceivableFromPool | currency: 'INR': 'symbol': '1.2-2' }}</th></tr>
            <tr><th colspan="6">Total (c+f-g) (Rs.)</th><th>{{ totalCharge() | currency: 'INR': 'symbol': '1.2-2' }}</th></tr>
            <tr><th colspan="6">Delayed Payment Charges (1.25%) (Rs.)</th><th>{{ delayedPaymentCharge() | currency: 'INR': 'symbol': '1.2-2' }}</th></tr>
            <tr><th colspan="6">Net Total Payable (Rs.)</th><th>{{ netPayable() | currency: 'INR': 'symbol': '1.2-2' }}</th></tr>
          </tfoot>
        </table>
      </div>
    </section>
  </div>
</main>
